
<template>
    <div>
        <div class="clearfix module-approver">
            <b-tabs content-class="">
                <template v-for="(this_module , index) in $modules">
                    <template v-if="index==7 || index==8 || index==9">
                        <b-tab :title="this_module">
                            <advance-settlement-approver-map-approver :pageurl="pageurl" :current_module="index" lazy></advance-settlement-approver-map-approver>
                        </b-tab>
                    </template>
                </template>

            </b-tabs>
        </div>

    </div>
</template>
<script>
    export default{

        mounted() {

        },
        props: ['pageurl','current_module'],
        components: {
        },
        data(){

            return {



            }
        },
        methods:{


        },
        created: function(){

        },
        computed:
        {

        }
    }
</script>
